export default __webpack_public_path__ + "static/media/about_me.215370bc.png";